<template>
	<div>
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			centered
		>
			<template #header-wrapper>
				<ModalHeaderWrapper title="Add Banner" @onClose="close" />
			</template>

			<template #default>
				<form>
					<BaseMediaSelectorBox
						ref="banner"
						v-model="$v.formData.banner.$model"
						title="Banner"
						no-image-text="No banner"
						show-helper
						:width="displayWidth"
						:height="displayHeight"
						class="mt-4"
						required
					/>

					<CRow v-if="forceName">
						<CCol md="6">
							<CInput
								v-model.trim="$v.formData.titleTh.$model"
								:is-valid="!$v.formData.titleTh.$error && null"
								:invalid-feedback="$t('global.error.required')"
								label="Title TH*"
							/>
						</CCol>
						<CCol md="6">
							<CInput
								v-model.trim="$v.formData.titleEn.$model"
								:is-valid="!$v.formData.titleEn.$error && null"
								:invalid-feedback="$t('global.error.required')"
								label="Title EN*"
							/>
						</CCol>
					</CRow>

					<CRow>
						<CCol md="12">
							<CInput
								v-model.trim="$v.formData.url.$model"
								:is-valid="!$v.formData.url.$error && null"
								:invalid-feedback="bannerLinkErrorMessage"
								:description="bannerLinkHelperText"
								:label="$t('components.contentWrapper.label.linkText', {required: ''})"
							/>
						</CCol>
					</CRow>
				</form>
			</template>

			<template #footer>
				<BaseModalFooter
					@onCancel="close"
					@onConfirm="handleSubmit"
				/>
			</template>
		</CModal>
	</div>
</template>

<script>
import { required, url, requiredIf } from 'vuelidate/lib/validators';

import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';
import BaseModalFooter from '@/components/BaseModalFooter.vue';
import BaseMediaSelectorBox from '@/components/BaseMediaSelectorBox.vue';

export default {
	name: 'ModalBanner',

	components: {
		ModalHeaderWrapper,
		BaseModalFooter,
		BaseMediaSelectorBox,
	},

	props: {
		displayWidth: {
			type: String,
			default: '1400',
		},
		displayHeight: {
			type: String,
			default: '700',
		},
		forceName: {
			type: Boolean,
			default: false,
		},
	},

	validations() {
		return {
			formData: {
				banner: {
					required,
				},
				url: {
					url,
				},
				titleTh: {
					required: requiredIf(() => this.forceName),
				},
				titleEn: {
					required: requiredIf(() => this.forceName),
				},
			},
		};
	},

	data() {
		return {
			isShow: false,
			formData: {
				banner: null,
				url: '',
				titleTh: '',
				titleEn: '',
			},
		};
	},

	computed: {
		bannerLinkErrorMessage() {
			if (!this.$v.formData.url.url) {
				return this.$t('page.banner.create.linkBannerInvalidFormat');
			} else if (!this.$v.formData.url.required) {
				return this.$t('global.error.required');
			}
			return null;
		},

		bannerLinkHelperText() {
			return this.bannerLinkErrorMessage === null
				? this.$t('page.banner.create.linkBannerHelperText')
				: null;
		},
	},

	methods: {
		open(data) {
			this.formData.banner = data?.banner || null;
			this.formData.url = data?.url || '';
			this.formData.titleTh = data?.titleTh || '';
			this.formData.titleEn = data?.titleEn || '';

			this.isShow = true;
		},

		close() {
			this.isShow = false;
		},

		clear() {
			this.formData = {
				banner: null,
				url: '',
				titleTh: '',
				titleEn: '',
			};
		},

		handleSubmit() {
			this.$refs.banner.$v.$touch();
			this.$v.$touch();
			if (this.$v.$invalid || this.$refs.banner.$v.$invalid) {
				return;
			}

			this.$emit('onConfirm', {
				banner: this.formData.banner,
				url: this.formData.url,
				...(
					this.forceName
						? {
							titleTh: this.formData.titleTh,
							titleEn: this.formData.titleEn,
						}
						: {}
				),
			});
			this.close();
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog {
	max-width: 650px;
}
</style>